/* eslint-disable */

// Import directly from node-modules
import $ from 'jquery';
import _debounce from 'lodash/debounce';

export default class ImageMontage {
    constructor(
        id = '#container',
        cw = 25,
        ch = 25,
        rand = false,
        mustFit = false,
        gut = 5,
        amt = 25,
        dur = 1,
        plhdr = '',
        isEditor = false,
        onResizeLayoutUpdateCallback = () => {}
    ) {
        this.rootId = id;
        this.cw = cw;
        this.ch = ch;
        this.rand = rand;
        this.mustFit = mustFit;
        this.gut = gut;
        this.amt = amt;
        this.dur = dur;
        this.plhdr = decodeURIComponent(plhdr);
        this.isEditor = isEditor;
        this.onResizeLayoutUpdateCallback = onResizeLayoutUpdateCallback;

        $('.layout').css('padding', `${gut}px`);
    }
    initBricks = overrideAmt => {
        const cw = this.cw,
            ch = this.ch,
            gut = this.gut,
            amt = overrideAmt || this.amt,
            isEditor = this.isEditor,
            plhdr = this.plhdr;
        let w = 1,
            h = 1,
            html = '';
        switch (amt) {
            case 3:
                w = Math.floor((window.innerWidth - gut * 2) / 2);
                h = Math.floor((window.innerHeight - gut * 4) / 2);
                html += `
                    <div class='brick' style='width: ${w}px; height: ${h}px; background: url(${plhdr}) no-repeat center center ${
                    plhdr === '' ? popRandColor() : ', linear-gradient(135deg, #ddd, #eee)'
                };'>
                        <img class='cover' />
                    </div>
                    <div class='brick' style='width: ${w}px; height: ${h}px; background: url(${plhdr}) no-repeat center center ${
                    plhdr === '' ? popRandColor() : ', linear-gradient(135deg, #ddd, #eee)'
                };'>
                <img class='cover' />
                </div>
                <div class='brick' style='width: ${w}px; height: ${
                    window.innerHeight
                }px; background: url(${plhdr}) no-repeat center center ${
                    plhdr === '' ? popRandColor() : ', linear-gradient(135deg, #ddd, #eee)'
                };'>
                    <img class='cover' />
                </div>
            `;
                break;

            default:
                for (var i = 0; i < amt; i++) {
                    if (this.rand) {
                        w = randBetween(0.9, 1.2);
                        h = randBetween(0.9, 1.2);
                    }
                    w *= ((window.innerWidth * cw) / 100) * w;
                    h *= ((window.innerHeight * ch) / 100) * h;
                    html += `
                    <div
                        class='brick'
                        style='
                            width: ${w}px;
                            height: ${h}px;
                            background: url(${plhdr}) no-repeat center center ${
                        plhdr === '' ? popRandColor() : ', linear-gradient(135deg, #ddd, #eee)'
                    };
                            ${isEditor && 'background-size: cover;'}
                        '>
                        <img class='cover' />
                    </div>
                `;
                }
                break;
        }
        $(this.rootId).html(html);
        this.freewall();
    };

    preloadImage = arr => {
        $('#preload').html(``);
        arr.forEach(info => {
            info.type === 'image' && $('#preload').append(`<img src='${info.value}' />`);
        });
    };

    fixSize = data => {
        const { target, parent, child } = data;
        const res = fitSize(parent, child);
        const style = `
        display: block;
        width: ${res.width}px;
        height: ${res.height}px;
        ${res.fitHeight ? `margin-left: -` : `margin-top: -`}${res.center}px;
    `;
        $(target).attr('style', style);
    };
    onResizeHandler = _debounce(() => {
        this.initBricks();
        this.onResizeLayoutUpdateCallback();
    }, 500);

    freewall = () => {
        const wall = new Freewall(this.rootId);
        const gut = this.gut;
        wall.reset({
            selector: '.brick',
            gutterX: gut,
            gutterY: gut,
            onResize: this.onResizeHandler,
            onComplete: () => {
                $.each($('.brick').children(), (i, val) => {
                    let $ele = $(val);
                    this.fixSize({
                        target: $ele,
                        parent: {
                            width: $ele.parent().css('width'),
                            height: $ele.parent().css('height')
                        },
                        child: {
                            width: $ele.css('width'),
                            height: $ele.css('height')
                        }
                    });
                });
            }
        });
        wall.fitZone($(window).width() - gut * 2, $(window).height() - gut * 2);
    };

    displayImages = data => {
        this.preloadImage(data);
        const allBrickImages = $('.brick .cover');
        const visibleBrickImages = [];

        for (let element of allBrickImages) {
            $(element).css('width') !== '0px' &&
                $(element).css('opacity') !== '0' &&
                visibleBrickImages.push(element);
        }

        let i = setInterval(() => {
            const $target = $(visibleBrickImages.splice(0, 1));
            const obj = data.shift();
            if (obj === undefined) {
                clearInterval(i);
            } else {
                this.generateImages({ obj, $target });
            }
        }, this.dur * 1000);
    };

    generateImages = data => {
        const {
            obj: { type, value, linkTo },
            $target
        } = data;

        // width and height of brick
        const pWidth = parseInt($target.parent().css('width'), 10);
        const pHeight = parseInt($target.parent().css('height'), 10);

        let html, $ele;
        switch (type) {
            case 'image':
                html = `
            <img
                src="${value}"
                class="cover ${!!linkTo ? 'clickable' : ''}"
                onClick="if(!!'${linkTo}')window.open('${linkTo}')"
            />`;
                $ele = $(html).on('load', () => {
                    // natural width and height of image
                    const nWidth = $ele.prop('naturalWidth');
                    const nHeight = $ele.prop('naturalHeight');
                    if (
                        this.mustFit &&
                        ((pWidth > pHeight && nWidth < nHeight) ||
                            (pWidth < pHeight && nWidth > nHeight))
                    )
                        return;
                    this.brickFadeOut({
                        $target,
                        $ele,
                        pWidth,
                        pHeight,
                        cWidth: nWidth,
                        cHeight: nHeight
                    });
                });

                break;
            case 'video':
                html = `
            <iframe
                src="https://www.facebook.com/plugins/video.php?href=${url}&show_text=0&rel=0&autoplay=1"
                style="width:1600px;height:900px;border:none;overflow:hidden;"
                class="cover ${!!linkTo ? 'clickable' : ''}"
                scrolling="no"
                frameborder="0"
                allowTransparency="false"
                allowFullScreen="false"
                onClick="if(!!${linkTo})window.open('${linkTo}')"
            ></iframe>`;
                $ele = $(html);
                this.brickFadeOut({
                    $target,
                    $ele,
                    pWidth,
                    pHeight,
                    cWidth: 1600,
                    cHeight: 900
                });
                break;
        }
    };

    brickFadeOut = data => {
        const { $target, $ele, pWidth, pHeight, cWidth, cHeight } = data;

        $target
            .parent()
            .fadeOut(500, () => {
                $target.replaceWith($ele);
                this.fixSize({
                    target: $ele,
                    parent: {
                        width: pWidth,
                        height: pHeight
                    },
                    child: {
                        width: cWidth,
                        height: cHeight
                    }
                });
            })
            .fadeIn(500);
    };
}

function popRandColor() {
    const colour = [
        'lightblue',
        'lightcyan',
        'lightcoral',
        'lightpink',
        'lightgrey',
        'lightgreen',
        'lightsalmon',
        'lightskyblue',
        'lightseagreen'
    ];
    return colour[(colour.length * Math.random()) << 0];
}

function randBetween(a, b) {
    return a + (b - a) * Math.random();
}

function fitSize(parent, child) {
    const pWidth = parseInt(parent.width, 10);
    const pHeight = parseInt(parent.height, 10);
    const cWidth = parseInt(child.width, 10);
    const cHeight = parseInt(child.height, 10);
    const nWidth = (cWidth * pHeight) / cHeight;
    const nHeight = (cHeight * pWidth) / cWidth;
    const centerX = (nWidth - pWidth) / 2;
    const centerY = (nHeight - pHeight) / 2;
    const fitHeight = nHeight < pHeight;
    return Object.assign(
        {},
        {
            fitHeight
        },
        fitHeight
            ? {
                  width: nWidth,
                  height: pHeight,
                  center: centerX
              }
            : {
                  width: pWidth,
                  height: nHeight,
                  center: centerY
              }
    );
}
